import React from 'react'
import Navbar from './Navbar'
import Trending from './Trending'

const Home = () => {
  return (
    <>
      <Navbar/>
      <Trending/>
    </>
  )
}

export default Home
